/* Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. */

import { Route } from '@angular/router';
import { RallyComponent } from './rally/rally.component';
import { RallyStartComponent } from './rally-start/rally-start.component';
import { Login2Component } from '../auth/components/login2/login2.component';
import { LoginComponent } from '../auth/components/login/login.component';
import { SignUpComponent } from '../auth/components/sign-up/sign-up.component';
import {
	isRallyCodeValid,
	isRallyRouteResolver,
	preloadRallyData,
	redirectIfSSOLoginHappened,
} from './rally-point-resolver.service';
import { canActivateLogin2 } from 'src/app/services/routing/login2-route-guard.service';
import { isNotSSOAndAuthGuard } from '../auth/guards/auth-guards';
import { SignUpValidationComponent } from '../auth/components/sign-up-validation/sign-up-validation.component';
import { NotAuthenticatedGuard } from 'src/app/services/routing/not-authenticated-guard.service';

const rallyRoutes: Route[] = [
	{
		path: '',
		component: RallyComponent,
		canActivate: [preloadRallyData],
		canActivateChild: [isRallyCodeValid],
		children: [
			{
				path: '',
				pathMatch: 'full',
				redirectTo: 'start',
			},
			{
				path: 'start',
				component: RallyStartComponent,
			},
			{
				path: 'login',
				component: LoginComponent,
				resolve: {
					isRallyRoute: isRallyRouteResolver,
				},
				canActivate: [redirectIfSSOLoginHappened],
			},
			{
				path: 'login2',
				component: Login2Component,
				canActivate: [canActivateLogin2],
			},
			{
				path: 'signup-validation',
				component: SignUpValidationComponent,
				canActivate: [NotAuthenticatedGuard],
			},
			{
				path: 'signup',
				component: SignUpComponent,
				canActivate: [isNotSSOAndAuthGuard],
			},
		],
	},
];

export default rallyRoutes;
